<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>Select Image(s) to import</CCardHeader>
      <CCardBody v-if="imageOptions">
        <div class="col-sm-6 col-md-3 float-left" style="height:200px;text-align:center;border:1px solid grey;border-radius:5px;padding:5px;" v-for="image in imageOptions">
          <div style="width:100%;float:left;height:150px;">
            <image-wrapper @img-clicked="viewImage(image)" :auto_load="true" imgStyle="max-width:100%;max-height:100%;cursor:pointer;" :src="image.file_url" />
          </div>
          <div style="width:100%;float:left;height:50px;text-align:center;">
            <CButton size="sm" :color="configureSelected(image) ? 'success' : 'outline-info'" @click="clicked(image)">{{configureSelected(image) ? 'Image Selected' : 'Select Image'}}</CButton>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <vue-gallery :images="currentViewImage" :index="galleryIndex" @close="modalClose()"></vue-gallery>
  </div>
</template>
<script>
import VueGallery from 'vue-gallery'
var methods = {}

methods.viewImage = function (image) {
  this.currentViewImage = [image.file_url]
  this.galleryIndex = 0
}

methods.configureSelected = function (image) {
  var i = 0
  var z = ''
  this.selectedImages.forEach(function (img) {
    if (image.id === img.id) {
      z = i
    }
    i++
  })
  if (z) {
    return true
  } else {
    return false
  }
}

methods.clicked = function (image) {
  var i = 0
  var z = ''
  this.selectedImages.forEach(function (img) {
    if (image.id === img.id) {
      z = i
    }
    i++
  })
  if (z) {
    this.selectedImages.splice(z, 1)
  } else {
    this.selectedImages.push(image)
  }
}

methods.modalClose = function () {
  this.currentViewImage = []
  this.galleryIndex = null
}

export default {
  // ===Component name
  name: "SelectImages",
  // ===Props passed to component
  props: ['group'],
  // ===Components used by this component
  components: {
    VueGallery
  },
  // ====component Data properties
  data(){
      return{
        currentViewImage: null,
        galleryIndex: null,
        selectedImages: [],
        imageOptions: null
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    console.log(this.group)
    var obj = {}
    var arr = []
    this.group.order_items.forEach(function (item) {
      item.order_item_locations.forEach(function (location) {
        if (!obj[location.decoration.id]) {
          obj[location.decoration.id] = true
          arr.push(location.decoration)
        }
      })
    })
    this.imageOptions = arr
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
